import { RootState } from 'store/types';

export const selectModal = (state: RootState) => {
  return state.modal;
};
